/**
 * Redirect mapping for legacy URLs, blog posts, and other custom redirects
 *
 * Single source of truth: `packages/server/src/redirects.ts`.
 * Use `resolveRedirectPath` for prefix rules (e.g. legacy VP edition branch URLs).
 *
 * Server ships a `default` export alongside named exports so this package can use
 * a default import under `esModuleInterop` (Node/tsx + TypeScript both agree).
 */
import serverRedirectsDefault from "../../../server/src/redirects";

type ServerRedirectsApi = {
    appendQueryString: (target: string, search: string) => string;
    queryStringOf: (rawUrl: string) => string;
    redirectMapping: Record<string, string>;
    resolveRedirectPath: (rawPath: string) => string | undefined;
    isGonePath: (rawPath: string) => boolean;
    normalizePathname: (pathname: string) => string;
};

const serverRedirects = serverRedirectsDefault as ServerRedirectsApi;

export const appendQueryString: ServerRedirectsApi["appendQueryString"] = serverRedirects.appendQueryString;
export const queryStringOf: ServerRedirectsApi["queryStringOf"] = serverRedirects.queryStringOf;
export const redirectMapping: Record<string, string> = serverRedirects.redirectMapping;
export const resolveRedirectPath: ServerRedirectsApi["resolveRedirectPath"] = serverRedirects.resolveRedirectPath;
export const isGonePath: ServerRedirectsApi["isGonePath"] = serverRedirects.isGonePath;
export const normalizePathname: ServerRedirectsApi["normalizePathname"] = serverRedirects.normalizePathname;
